import React, {useState, useEffect,useRef } from 'react'
import { useReactToPrint } from 'react-to-print';
import attendanceServices from '../attendanceServices';
import MonthlyDateSelect from '../../../../../components/AppInput/MonthlyDateSelect';
import CalculateHours from '../../../../../components/CalculateHours';
import moment from 'moment';
import CalculateTotalWorkingHours from '../../../../../components/CalculateTotalWorkingHours';
import { useAppData } from '../../../../../context/AppDataContext';
import UpdatePunchForm from './UpdatePunchForm';
import { Print } from '@mui/icons-material';

function EmployeeAttendanceList({employeeId}) {

    const printComponentRef = useRef();
    const {employeeDD,getDDDataById} = useAppData();
    const [filter,setFilter] = useState(null);
    const [attendanceList,setAttendanceList] = useState(null);
    const [isPrinting,setIsPrinting] = useState(false);

    const getAttendanceByEmployee = () =>{
        attendanceServices.getAttendanceByEmployee(employeeId,filter).then(res=>{
            setAttendanceList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }


    const printVoucher = () =>{
        setIsPrinting(true);
        setTimeout(handlePrint,100)
    }

    const handlePrint = useReactToPrint({
        content: () => printComponentRef.current,
        onAfterPrint : ()=>{
            setIsPrinting(false);
        },
        // Standard A4 or Letter size logic
        pageStyle: `
            @page { 
                size: auto; 
                margin: 10mm; 
            }
            @media print {
                body { -webkit-print-color-adjust: exact; }
            }
        `
      });

    useEffect(()=>{
        getAttendanceByEmployee()
    },[filter])

    return (
        <div className='row'>
            <div className='col-md-12'>
                <h4 className='float-start' >{getDDDataById(employeeDD,employeeId).label} Attendance</h4>
            </div>
            <div className='col-md-12'>
                <UpdatePunchForm employeeId={employeeId} callBack={getAttendanceByEmployee}  />
                <span className='float-end'>
                    <button className='btn btn-outline-primary float-end ms-2' onClick={printVoucher} ><Print /> Print</button>
                    Date : <MonthlyDateSelect filter={filter} setFilter={setFilter} />
                </span>
            </div>
            <div className='col-md-12' ref={printComponentRef}>
                <table className='table table-striped table-sm'>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>In Time</th>
                            <th>Out Time</th>
                            <th>Hours</th>
                            <th>Edit By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attendanceList && attendanceList.map((punch)=>
                            <tr key={punch.id} className={punch.updatedBy !== null ? 'table-danger':""}>
                                <td>{moment(punch.inTime).format("DD-MM-YYYY, ddd")}</td>
                                <td>{moment(punch.inTime).format("hh:mm a")}</td>
                                <td>{punch.outTime !== null ?
                                        moment(punch.outTime).format("hh:mm a")
                                        :
                                        "--------"
                                    }
                                </td>
                                <td> {punch.outTime !== null ?
                                        <CalculateHours inTime={punch.inTime} outTime={punch.outTime} />
                                        :
                                        <div>--------</div>
                                    }
                                </td>
                                <td>
                                    <UpdatePunchForm data={punch} callBack={getAttendanceByEmployee} isPrinting={isPrinting} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                    {attendanceList &&
                        <tfoot>
                            <tr>
                                <td colSpan={5}>
                                    <CalculateTotalWorkingHours punchList={attendanceList} />
                                </td>
                            </tr>
                        </tfoot>
                    }
                </table>
            </div>
        </div>
    )
}

export default EmployeeAttendanceList